import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
	connect() {
		this.element.querySelectorAll('select, input[type="checkbox"], input[type="radio"]').forEach((control) => {
			control.addEventListener('change', () => this.element.requestSubmit())
		})
	}
}
